import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import ControllerTable from "../../../Components/Table/ControllerTable";
import CustomButton from "../../../Components/Button/CustomButton";
import { Link } from "react-router-dom";
import { GetSubAdmins } from "../../../APIs/Function/Controller/GetSubAdmin";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";

const Controller = () => {
  const [controllerData, setControllerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const handleController = async () => {
    try {
      setLoading(true);
      let res = await GetSubAdmins();
      setLoading(false);
      setControllerData(res.r);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = (e.target.value || "");
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(9, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleController();
  }, []);
  return (
    <>
      <Box>
        {/* searchbar */}
        <Box sx={{ boxSizing: "border-box", p: 2 }}>
          <Box>
            <Searchbar placeholder={"Search User"} onChange={handleSearch} />
          </Box>
          {searched && searchData.length > 0 ? (
            <ControllerTable
              Column1={"#"}
              Column2={"Email"}
              column3={"No of Accesses"}
              Column4={"Action"}
              data={searchData}
              setData={setControllerData}
              loading={loading}
              setLoading={setLoading}
            />
          ) : !searched ? (
            <ControllerTable
              Column1={"#"}
              Column2={"Email"}
              column3={"No of Accesses"}
              Column4={"Action"}
              data={controllerData}
              setData={setControllerData}
              loading={loading}
              setLoading={setLoading}
            />
          ) : (
            ""
          )}
          {/* <Box>
            <ControllerTable
              Column1={"#"}
              Column2={"Email"}
              column3={"No of Accesses"}
              Column4={"Action"}
              data={controllerData}
              setData={setControllerData}
              loading={loading}
              setLoading={setLoading}
            />
          </Box>{" "} */}
          <Box
            sx={{
              display: "flex",
              mt: "25px",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Link to={"/addcontroller"}>
              <CustomButton
                sx={{
                  width: "100%",
                  bgcolor: "#31AEF4",
                  "&:hover": {
                    bgcolor: "#31AEF4",
                  },
                }}
              >
                ADD +
              </CustomButton>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Controller;
